<template>
<div>
  <div class="row align-items-center ">
    <div v-if="loading" class="col-12 text-center">
      <LoadingSpinner></LoadingSpinner>
    </div>
    <div v-show="!loading" class="col-6 text-center">
      <div class="donut-chart" :id="'canvas-consumptiondetails-'+id"></div>
    </div>
    <div v-show="!loading" class="col-6 text-left">
      <span class="percentage blue font-weight-bold">{{ percentage }}%</span>
      <p> 
        {{ $t('of_the_energy_consumed') }}
        <span v-if="current_page == 'Comparison'"> 
          <span v-if="range =='day'">{{ $t('this_day') }} </span> 
          <span v-if="range =='week'">{{ $t('this_week') }} </span> 
          <span v-if="range =='month'">{{ $t('this_month') }} </span> 
        </span>
        <span v-else>
          <span v-if="range =='hour'">{{ $t('in_last_hour') }} </span> 
          <span v-if="range =='day'">{{ $t('in_last_24_hours') }} </span> 
          <span v-if="range =='week'">{{ $t('in_last_7_days') }} </span> 
          <span v-if="range =='month'">{{ $t('in_last_30_days') }} </span> 
        </span>
        {{ $t('was_produced_by_system') }}!
      </p>
    </div>
  </div>
</div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue' 

export default {
  name: 'ConsumptionDetailsDonut',
  props: ['data', 'id'],
  components: {
    LoadingSpinner
  },
  data(){
    return {
      chart: null,
      sec: 0,
      clock: null
    }
  },
  mounted(){
    const self = this
    this.chart = Highcharts.chart(`canvas-consumptiondetails-${this.id}`,  { 
      chart: {
        type: 'variablepie',
        backgroundColor: '#fff'
      },
      credits: { enabled: false },
      title: {
        text: ''
      },
      tooltip: 
      {
        shared: true,
        formatter: function() {
          return '<span style="color:'+ this.point.color +'">\u25CF</span> <b>' + this.point.name + '</b>: '+ this.point.y +'%<br/>';
        }
      },
      series: [{
        minPointSize: 0,
        innerSize: '60%',
        zMin: 0,
        name: 'Energy', 
        data: [{},{}] 
      }],
      plotOptions: {
        series: {
          events: {
            mouseOver: function () {
              self.clock = setInterval(function(){ self.sec++;  }, 1000)
            },
            mouseOut: function (e) {
              clearInterval(self.clock);
              if (self.sec > 1) _paq.push(['trackEvent', 'Geral', 'Gráfico Detalhes do consumo', 'MouseOver', self.sec])
              self.sec = 0
            } 
          }
        }
      }
    }) 
  },
  methods: {
    set_values: function(){
      if (this.data == {} || this.data == null) {
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t('No_Data'))
        return
      }
      let series = [{
          name: this.$i18n.t('Production'),
          y: 0,
          z: 50,
          color: '#4187c7',
          dataLabels: {
            enabled: false,
            formatter: function () { 
              if (this.y > 0 && this.y < 5) { 
                  this.series.data[0].dataLabels.distance = 30; 
                  return this.y+"%";
              }
              else if (this.y >= 5) {
                  this.series.data[0].dataLabels.distance = -15; 
                  return this.y+"%";
              }
            } 
          }
        }
      ]

      if (this.has_battery) {
        series.push({
          name: this.$i18n.t('Battery'),
          y: 0,
          z: 50,
          color: '#89b43f',
          dataLabels: {
            enabled: false,
            formatter: function () { 
              if (this.y > 0 && this.y < 5) { 
                  this.series.data[1].dataLabels.distance = 30; 
                  return this.y+"%";
              }
              else if (this.y >= 5) {
                  this.series.data[1].dataLabels.distance = -15; 
                  return this.y+"%";
              }
            } 
          }
        })
      }

      series.push({
        name: this.$i18n.t('Electric_grid'),
        y: 0,
        z: 35,
        color: '#ef5e3c',
        dataLabels: {
          enabled: false,
          formatter: function () { 
            if (this.y > 0 && this.y < 5) { 
              this.series.data[1].dataLabels.distance = 30; 
              return this.y+"%";
            }
            else if (this.y >= 5) {
              this.series.data[1].dataLabels.distance = -15; 
              return this.y+"%";
            }
          }
        }
      })

      /* let series = [{
          name: this.$i18n.t('Production'),
          y: 0,
          z: 50,
          color: '#4187c7',
          dataLabels: {
            enabled: false,
            formatter: function () { 
              if (this.y > 0 && this.y < 5) { 
                  this.series.data[0].dataLabels.distance = 30; 
                  return this.y+"%";
              }
              else if (this.y >= 5) {
                  this.series.data[0].dataLabels.distance = -15; 
                  return this.y+"%";
              }
            } 
          }
        }, 
        {
          name: this.$i18n.t('Electric_grid'),
          y: 0,
          z: 35,
          color: '#ef5e3c',
          dataLabels: {
            enabled: false,
            formatter: function () { 
              if (this.y > 0 && this.y < 5) { 
                this.series.data[1].dataLabels.distance = 30; 
                return this.y+"%";
              }
              else if (this.y >= 5) {
                this.series.data[1].dataLabels.distance = -15; 
                return this.y+"%";
              }
            }
          }
        }
      ] */

      //series[0].y = Math.round((parseFloat(this.data.PV_House)*100) / (parseFloat(this.data.PV_House) + parseFloat(this.data.Grid_House)))
      series[0].y = Math.round((parseFloat(this.data.PV_House)*100) / (parseFloat(this.data.Batt_House) + parseFloat(this.data.PV_House) + parseFloat(this.data.Grid_House)))
      if (this.has_battery) {
        series[1].y = Math.round((parseFloat(this.data.Batt_House)*100) / (parseFloat(this.data.Batt_House) + parseFloat(this.data.PV_House) + parseFloat(this.data.Grid_House)))
        series[2].y = Math.round(100 - series[0].y - series[1].y)
      }
      else {
        series[1].y = Math.round(100 - series[0].y)
      }
      
      this.chart.series[0].setData(series, false)

      if (this.data == {} || (this.data.PV_House == null && this.data.Grid_House == null && this.data.Batt_House == null)){
        this.chart.hideNoData()
        this.chart.showNoData(this.$i18n.t('No_Data'))
      }
      this.chart.redraw()
    }
  },
  watch: {
    data: {
      handler(){
        this.set_values()
      },
      deep:true
    },
    current_lang: function(){
      this.chart.series[0].data[0].update({ name: this.$i18n.t('Production') }, false);
      if (this.has_battery) {
        this.chart.series[0].data[1].update({ name: this.$i18n.t('Battery') }, false);
        this.chart.series[0].data[2].update({ name: this.$i18n.t('Electric_grid') }, false);
      } else this.chart.series[0].data[1].update({ name: this.$i18n.t('Electric_grid') }, false);
      this.chart.redraw()
    }
  },
  computed: {
    percentage: function(){
      if (this.data && this.data.PV_House != null && this.data.Grid_House != null && this.data.PV_House != null ) {
        if (this.data.PV_House == 0 && this.data.Grid_House == 0) return 0
        return Math.round((parseFloat(this.data.PV_House)*100) / (parseFloat(this.data.Batt_House) + parseFloat(this.data.PV_House) + parseFloat(this.data.Grid_House)))
        //return Math.round((parseFloat(this.data.PV_House)*100) / (parseFloat(this.data.PV_House) + parseFloat(this.data.Grid_House)))
      }
      else return ''
    },
    range: function(){
      return this.$store.getters.range
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      return this.$store.getters.user_bess
    }, 
    current_page: function(){
      return this.$route.name
    },
    loading: function(){
      return this.$store.getters.data_loading
    },
    current_lang: function(){
      return this.$i18n.locale
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#canvas-consumptiondetails-1 {
  height: 220px;
}
.donut-chart {
  height: 220px;
}
.blue {
  color: #4187c7;
}
.percentage {
  font-size: 30pt;
}

@media only screen and (min-width: 768px) {
  .percentage {
    font-size: 60pt;
  }
}
</style>
